// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b1b887ad","337":"2f78c0c3","453":"d3f2ab92","455":"75792278"}[chunkId] + ".chunk.js";
};